import React from "react";
import { HSeparator } from "./customStyled";
import { Input, Label } from "reactstrap";
import CpmCommTooltip from "./CpmCommTooltip";

/**
 *
 * @User : 백욱진
 * @Date : 2023.05.10
 * @file : Components/Common/CpmCommCodeRadio.js
 * @Desc : 공통코드 라디오버튼 컴포넌트
 * @param {string} id - id값 (부모 컴포넌트의 파라미터 key 값으로도 사용)
 * @param {Object} cmCodes - 공통코드 데이터 {label: string, value: string, tooltip?: string, disabled?: boolean,}
 * @param {string} params - 부모 컴포넌트로부터 받아온 선택값
 * @param {React.SetStateAction} setParams - 부모 컴포넌트로부터 받아온 파라미터 세터
 * @param {boolean} isDBlock - display : block Yn (default: false (flex))
 * @param {boolean} isDisabled - disabled 여부
 */

const CpmCommCodeRadio = ({
  id,
  cmCodes,
  params,
  setParams,
  isDBlock,
  isDisabled,
  classname = "" ,
  background
}) => {
  const paramNm = id || "cmCodeRadio"; // param 이름
  const data = cmCodes || [
    { label: "MC", value: 1 },
    { label: "광고회사", value: 2 },
    { label: "방송사", value: 3 },
    { label: "광고주", value: 4 },
    { label: "조사기관", value: 5 },
  ];

  // 라디오 체크 시 상태 변경 함수
  const handleRadioChange = (e) => {
    const value = e.target.value === "" ? null : e.target.value; 
    setParams({ [paramNm]: value }); // 부모 파라미터 값 변경
  };

  return (
    <div className={`${isDBlock ? null : "d-flex flex-wrap"}`}>
      {data.map((el, idx) => {
        if (el) {
          return (
            <div key={`Form_Radio_${el.value}_${idx}`} className={`d-flex ${classname} `}   >
              <div className="d-form-check  d-flex align-items-center" >
                <Input
                  className="form-check-input me-1"
                  type="radio"
                  value={el.value || ''}
                  /*defaultChecked = {(el.value === params[paramNm]) ? true : false }*/
                  onChange={handleRadioChange}
                  name={`radio_${id}`}
                  id={`radio_${id}_${el.value}`}
                  disabled={isDisabled || el.disabled}
                  checked = {(el.value === params[paramNm]||'') }
                />
                <Label
                  className="form-check-label text-nowrap"
                  htmlFor={`radio_${id}_${el.value}`}
                >
                  {el.label}
                </Label>
                {el.tooltip && (
                  <CpmCommTooltip id={el.value} disc={el.tooltip} />
                )}
              </div>
              <HSeparator />
            </div>
          );
        }
        return <></>;
      })}
    </div>
  );
};

export default CpmCommCodeRadio;
